(function () {
  function initIntroGate() {
    var section = document.querySelector("[data-intro-gate]");
    if (!section) {
      return;
    }
    if (section.dataset.introGateInitialized === "true") return;

    section.dataset.introGateInitialized = "true";

    var body = document.body;
    if (!body) return;

    var revealDelayMs = parseInt(section.getAttribute("data-reveal-delay-ms"), 10) || 3000;
    var fadeDurationMs = parseInt(section.getAttribute("data-fade-duration-ms"), 10) || 1000;
    var hasPostMedia = section.getAttribute("data-has-post-media") === "true";
    var showIntroOncePerVisit = section.getAttribute("data-show-intro-once-per-visit") === "true";
    var sessionKey = section.getAttribute("data-intro-gate-session-key") || "";
    var isDesignMode = !!(window.Shopify && window.Shopify.designMode);
    var visibleDelayMs = 0;
    var revealTimer;
    var revealPhaseTimer;
    var hasRevealed = false;
    var postMediaShown = false;
    var offsetRaf = null;
    var resizeHandler = null;

    function getVisitIntroSeen() {
      if (!showIntroOncePerVisit || !sessionKey || isDesignMode) return false;
      try {
        return window.sessionStorage && window.sessionStorage.getItem(sessionKey) === "1";
      } catch (_) {
        return false;
      }
    }

    function setVisitIntroSeen() {
      if (!showIntroOncePerVisit || !sessionKey || isDesignMode) return;
      try {
        if (window.sessionStorage) window.sessionStorage.setItem(sessionKey, "1");
      } catch (_) {}
    }

    function getHeaderOffset() {
      var selectors = [
        "#shopify-section-header-2",
        "#shopify-section-header",
        "[data-h2-header-root]",
        "[data-h2-header]",
        ".header-wrapper",
        ".site-header",
        "header[role='banner']"
      ];
      var seen = [];
      var maxBottom = 0;

      for (var i = 0; i < selectors.length; i++) {
        var nodes = document.querySelectorAll(selectors[i]);
        for (var j = 0; j < nodes.length; j++) {
          var el = nodes[j];
          if (!el || seen.indexOf(el) !== -1) continue;
          seen.push(el);
          var st = window.getComputedStyle(el);
          if (!st || st.display === "none" || st.visibility === "hidden") continue;
          var rect = el.getBoundingClientRect();
          if (rect.bottom <= 0) continue;
          if (rect.top > (window.innerHeight || document.documentElement.clientHeight) * 0.45) continue;
          maxBottom = Math.max(maxBottom, rect.bottom);
        }
      }

      return Math.max(0, Math.round(maxBottom));
    }

    function applyHeaderOffset() {
      if (!document.body) return;
      document.body.style.setProperty("--intro-gate-header-offset", getHeaderOffset() + "px");
    }

    function scheduleHeaderOffset() {
      if (offsetRaf) return;
      offsetRaf = window.requestAnimationFrame(function () {
        offsetRaf = null;
        applyHeaderOffset();
      });
    }

    function revealSite() {
      if (hasRevealed) return;
      hasRevealed = true;
      var headerRoots = document.querySelectorAll("[data-h2-header-root]");
      for (var i = 0; i < headerRoots.length; i++) {
        headerRoots[i].classList.remove("ab-hidden", "mobile-hidden");
      }
      body.classList.remove("intro-gate-preload");
      body.classList.remove("intro-gate-active");
      body.classList.add("intro-gate-revealing");
      body.classList.add("intro-gate-revealed");
      if (revealPhaseTimer) window.clearTimeout(revealPhaseTimer);
      revealPhaseTimer = window.setTimeout(function () {
        body.classList.remove("intro-gate-revealing");
      }, Math.max(0, fadeDurationMs));
    }

    function showPostMedia() {
      if (!hasPostMedia || postMediaShown) return;
      postMediaShown = true;
      section.classList.add("is-post-visible");

      var postVideos = section.querySelectorAll(".intro-video-gate__post-media video");
      for (var j = 0; j < postVideos.length; j++) {
        var postVideo = postVideos[j];
        if (!postVideo) continue;
        postVideo.muted = true;
        postVideo.defaultMuted = true;
        postVideo.playsInline = true;
        postVideo.setAttribute("muted", "");
        postVideo.setAttribute("playsinline", "");
        postVideo.setAttribute("loop", "");
        (function (videoNode) {
          var pp = videoNode.play && videoNode.play();
          if (pp && typeof pp.catch === "function") {
            pp.catch(function () {});
          }
        })(postVideo);
      }
    }

    var mobileBreakpoint = parseInt(section.getAttribute("data-mobile-breakpoint"), 10);
    if (!(mobileBreakpoint >= 0)) mobileBreakpoint = 749;
    var isMobile = window.matchMedia("(max-width: " + mobileBreakpoint + "px)").matches;
    var selector = isMobile
      ? ".intro-video-gate__video--mobile video"
      : ".intro-video-gate__video--desktop video";
    var video = section.querySelector(selector) || section.querySelector(".intro-video-gate__media video");
    if (!video) {
      body.classList.remove("intro-gate-preload");
      body.classList.remove("intro-gate-active");
      body.classList.add("intro-gate-revealed");
      return;
    }

    applyHeaderOffset();
    resizeHandler = scheduleHeaderOffset;
    window.addEventListener("resize", resizeHandler, { passive: true });

    if (getVisitIntroSeen()) {
      body.classList.remove("intro-gate-preload");
      body.classList.remove("intro-gate-active");
      body.classList.add("intro-gate-revealed");
      section.classList.add("is-visible");
      if (hasPostMedia) {
        showPostMedia();
      }
      return;
    }

    body.classList.add("intro-gate-active");
    body.classList.remove("intro-gate-preload");
    setVisitIntroSeen();

    window.setTimeout(function () {
      section.classList.add("is-visible");
    }, visibleDelayMs);

    revealTimer = window.setTimeout(revealSite, revealDelayMs);

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("autoplay", "");
    if (hasPostMedia) {
      video.loop = false;
      video.removeAttribute("loop");
    }

    var startTimerFromPlayback = function () {
      window.clearTimeout(revealTimer);
      revealTimer = window.setTimeout(revealSite, revealDelayMs);
    };

    video.addEventListener("playing", startTimerFromPlayback, { once: true });
    video.addEventListener("error", revealSite, { once: true });
    if (hasPostMedia) {
      video.addEventListener("ended", showPostMedia, { once: true });
    }

    var tryPlay = function () {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(function () {
          revealSite();
        });
      }
    };

    if (video.readyState >= 2) {
      tryPlay();
    } else {
      video.addEventListener("loadedmetadata", tryPlay, { once: true });
      video.addEventListener("canplay", tryPlay, { once: true });
    }

    document.addEventListener("shopify:section:unload", function handleUnload(event) {
      if (!event || !event.detail) return;
      if (String(event.detail.sectionId) !== String(section.id || section.getAttribute("id") || "").replace("intro-video-gate-", "")) return;
      if (revealTimer) window.clearTimeout(revealTimer);
      if (revealPhaseTimer) window.clearTimeout(revealPhaseTimer);
      if (offsetRaf) window.cancelAnimationFrame(offsetRaf);
      if (resizeHandler) window.removeEventListener("resize", resizeHandler, { passive: true });
      body.classList.remove("intro-gate-preload");
      body.classList.remove("intro-gate-active");
      body.classList.remove("intro-gate-revealing");
      document.removeEventListener("shopify:section:unload", handleUnload);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initIntroGate);
  } else {
    initIntroGate();
  }

  window.addEventListener("load", initIntroGate);
  document.addEventListener("shopify:section:load", initIntroGate);
})();
